import yup, { valueSelected } from '../../../../utils/yup'

export const adjustPriceSchema = yup.object().shape({
  price: yup.string().decimalAmountWithNegative(true),
  isTax: yup.bool(),
  reason: valueSelected(yup),
})
